import React from 'react';
import classNames from 'classnames';
import './CorporateActionsCapsuleContentFront.scss';
import {
    getCorporateActionCapsuleRowData,
    Row,
} from './corporateActionsCapsuleData';
import { CorporateActionsCapsuleConfigState } from 'widgets/corpActions/capsule/store/CorporateActionsCapsuleConfigState';
import { EnrichedSymbolEvent } from 'widgets/corpActions/store/data/earningsAftMktOnTMinus1.ts';

export interface CorporateActionsCapsuleFrontProps {
    config: CorporateActionsCapsuleConfigState;
    data: EnrichedSymbolEvent[];
    onRowClick: (row: Row) => void;
}

export function CorporateActionsCapsuleContentFront(
    props: CorporateActionsCapsuleFrontProps
) {
    const { config, data, onRowClick } = props;

    const rowData = getCorporateActionCapsuleRowData(data, config);

    const handleRowClick = (row: Row) => {
        if (row.uuid) {
            onRowClick(row);
        }
    };

    return (
        <div className="CorporateActionsCapsuleContentContainer">
            <div className="CorporateActionsCapsuleContentFront flippable">
                {rowData.map((row, i) => (
                    <CorporateActionCapsuleRow key={`row-${i}`} row={row} />
                ))}
            </div>
        </div>
    );

    function CorporateActionCapsuleRow(props: { row: Row }) {
        const { row } = props;

        const cssClasses = classNames(
            'row',
            row.isTminus1AftMftEarnings && 'aftmkt-earnings-ontminus1',
            row.type === 'Upcoming' && 'upcoming',
            row.type === 'Historical' && 'historical',
            row.type === 'Today' && 'today',
            row.uuid && 'clickable',
            !row.uuid && 'dummy-row'
        );
        return (
            <div className={cssClasses} onClick={() => handleRowClick(row)}>
                <RowLine />
                <div className="row-label">
                    {row.text} <span className="sub-text">{row.subText}</span>
                </div>
            </div>
        );
    }

    function RowLine() {
        return (
            <div className="row-line">
                <div className="row-line-top" />
                <div className="row-line-bottom" />
            </div>
        );
    }
}
